import api from '../api';
// Utils
import { normalizeUrl } from '../../utils/url';
// Mocks
// import mockDashboard from '../../mocks/mock-dashboard';

/**
 * Get dashboard data from an endpoint
 * @param {string} path - The path of the page (contains class_id and id)
 * @param {string} contexte - The context
 * @returns {Promise<ApiDashboardResponse>} The dashboard data
 */
export const getDashboard = async (path, contexte) => {
  // eslint-disable-next-line no-console
  console.log('path', path);

  // For now, return the mock
  // TODO: Uncomment when API is ready
  const response = await api.get(`/dashboard?path=${path}&contexte=${contexte}`);
  // console.log('response dashboard', response);
  return response.data;
  // return mockDashboard;
};

/**
 * Execute a dashboard action by POSTing to its already-composed URL
 * @param {string} actionUrl - The relative API URL to call
 * @returns {Promise<ApiDashboardActionResult>} The action result
 */
export const postDashboardAction = async (actionUrl) => {
  const response = await api.post(normalizeUrl(actionUrl));
  return response.data;
};
